const loggedIn = () => {
    return document.querySelector("input#loggedIn").value || false;
}

export default loggedIn;